
  /* 本文件未 autoview.js 自动生成  执行 npm run dir*/
	export default [

{
          path: '/external/advance/complete',
          name: 'externalAdvanceComplete', 
          component: () => import('@/view/external/advance/complete.vue'),
        },
{
          path: '/external/advance/detail',
          name: 'externalAdvanceDetail', 
          component: () => import('@/view/external/advance/detail.vue'),
        },
{
          path: '/external/allRisk/complete',
          name: 'externalAllriskComplete', 
          component: () => import('@/view/external/allRisk/complete.vue'),
        },
{
          path: '/external/allRisk/detail',
          name: 'externalAllriskDetail', 
          component: () => import('@/view/external/allRisk/detail.vue'),
        },
{
          path: '/external/applyFile',
          name: 'externalApplyfile', 
          component: () => import('@/view/external/applyFile.vue'),
        },
{
          path: '/external/basicPay',
          name: 'externalBasicpay', 
          component: () => import('@/view/external/basicPay.vue'),
        },
{
          path: '/external/bidChannel',
          name: 'externalBidchannel', 
          component: () => import('@/view/external/bidChannel.vue'),
        },
{
          path: '/external/bidding/complete',
          name: 'externalBiddingComplete', 
          component: () => import('@/view/external/bidding/complete.vue'),
        },
{
          path: '/external/bidding/detail',
          name: 'externalBiddingDetail', 
          component: () => import('@/view/external/bidding/detail.vue'),
        },
{
          path: '/external/biddingApplyFile',
          name: 'externalBiddingapplyfile', 
          component: () => import('@/view/external/biddingApplyFile.vue'),
        },
{
          path: '/external/biddingChannel',
          name: 'externalBiddingchannel', 
          component: () => import('@/view/external/biddingChannel.vue'),
        },
{
          path: '/external/bidSecurity/apply',
          name: 'externalBidsecurityApply', 
          component: () => import('@/view/external/bidSecurity/apply.vue'),
        },
{
          path: '/external/bidSecurity/detail',
          name: 'externalBidsecurityDetail', 
          component: () => import('@/view/external/bidSecurity/detail.vue'),
        },
{
          path: '/external/bidSecurity/gongcTenderbidJump',
          name: 'externalBidsecurityGongctenderbidjump', 
          component: () => import('@/view/external/bidSecurity/gongcTenderbidJump.vue'),
        },
{
          path: '/external/cancel',
          name: 'externalCancel', 
          component: () => import('@/view/external/cancel.vue'),
        },
{
          path: '/external/carRisk/detail',
          name: 'externalCarriskDetail', 
          component: () => import('@/view/external/carRisk/detail.vue'),
        },
{
          path: '/external/CaSeal',
          name: 'externalCaseal', 
          component: () => import('@/view/external/CaSeal.vue'),
        },
{
          path: '/external/channel',
          name: 'externalChannel', 
          component: () => import('@/view/external/channel.vue'),
        },
{
          path: '/external/claims/apply',
          name: 'externalClaimsApply', 
          component: () => import('@/view/external/claims/apply.vue'),
        },
{
          path: '/external/claims/detail',
          name: 'externalClaimsDetail', 
          component: () => import('@/view/external/claims/detail.vue'),
        },
{
          path: '/external/companyCheck',
          name: 'externalCompanycheck', 
          component: () => import('@/view/external/companyCheck.vue'),
        },
{
          path: '/external/companyCheckFail',
          name: 'externalCompanycheckfail', 
          component: () => import('@/view/external/companyCheckFail.vue'),
        },
{
          path: '/external/companyInfo',
          name: 'externalCompanyinfo', 
          component: () => import('@/view/external/companyInfo.vue'),
        },
{
          path: '/external/components/my-coupon-dialog',
          name: 'externalComponentsMy-coupon-dialog', 
          component: () => import('@/view/external/components/my-coupon-dialog.vue'),
        },
{
          path: '/external/contract/complete',
          name: 'externalContractComplete', 
          component: () => import('@/view/external/contract/complete.vue'),
        },
{
          path: '/external/contract/detail',
          name: 'externalContractDetail', 
          component: () => import('@/view/external/contract/detail.vue'),
        },
{
          path: '/external/cultural/complete',
          name: 'externalCulturalComplete', 
          component: () => import('@/view/external/cultural/complete.vue'),
        },
{
          path: '/external/cultural/detail',
          name: 'externalCulturalDetail', 
          component: () => import('@/view/external/cultural/detail.vue'),
        },
{
          path: '/external/customs/complete',
          name: 'externalCustomsComplete', 
          component: () => import('@/view/external/customs/complete.vue'),
        },
{
          path: '/external/customs/confirm',
          name: 'externalCustomsConfirm', 
          component: () => import('@/view/external/customs/confirm.vue'),
        },
{
          path: '/external/customs/detail',
          name: 'externalCustomsDetail', 
          component: () => import('@/view/external/customs/detail.vue'),
        },
{
          path: '/external/customs/jump',
          name: 'externalCustomsJump', 
          component: () => import('@/view/external/customs/jump.vue'),
        },
{
          path: '/external/govAdvance/complete',
          name: 'externalGovadvanceComplete', 
          component: () => import('@/view/external/govAdvance/complete.vue'),
        },
{
          path: '/external/govAdvance/detail',
          name: 'externalGovadvanceDetail', 
          component: () => import('@/view/external/govAdvance/detail.vue'),
        },
{
          path: '/external/govBidSecurity/detail',
          name: 'externalGovbidsecurityDetail', 
          component: () => import('@/view/external/govBidSecurity/detail.vue'),
        },
{
          path: '/external/govContract/complete',
          name: 'externalGovcontractComplete', 
          component: () => import('@/view/external/govContract/complete.vue'),
        },
{
          path: '/external/govContract/detail',
          name: 'externalGovcontractDetail', 
          component: () => import('@/view/external/govContract/detail.vue'),
        },
{
          path: '/external/h5pay',
          name: 'externalH5pay', 
          component: () => import('@/view/external/h5pay.vue'),
        },
{
          path: '/external/insurance/complete',
          name: 'externalInsuranceComplete', 
          component: () => import('@/view/external/insurance/complete.vue'),
        },
{
          path: '/external/insurance/confirm',
          name: 'externalInsuranceConfirm', 
          component: () => import('@/view/external/insurance/confirm.vue'),
        },
{
          path: '/external/insurance/confirmation',
          name: 'externalInsuranceConfirmation', 
          component: () => import('@/view/external/insurance/confirmation.vue'),
        },
{
          path: '/external/insurance/quote',
          name: 'externalInsuranceQuote', 
          component: () => import('@/view/external/insurance/quote.vue'),
        },
{
          path: '/external/jump',
          name: 'externalJump', 
          component: () => import('@/view/external/jump.vue'),
        },
{
          path: '/external/lawsuit/apply',
          name: 'externalLawsuitApply', 
          component: () => import('@/view/external/lawsuit/apply.vue'),
        },
{
          path: '/external/lawsuit/complete',
          name: 'externalLawsuitComplete', 
          component: () => import('@/view/external/lawsuit/complete.vue'),
        },
{
          path: '/external/lawsuit/completeByJump',
          name: 'externalLawsuitCompletebyjump', 
          component: () => import('@/view/external/lawsuit/completeByJump.vue'),
        },
{
          path: '/external/lawsuit/correcting',
          name: 'externalLawsuitCorrecting', 
          component: () => import('@/view/external/lawsuit/correcting.vue'),
        },
{
          path: '/external/lawsuit/detail',
          name: 'externalLawsuitDetail', 
          component: () => import('@/view/external/lawsuit/detail.vue'),
        },
{
          path: '/external/lawsuit/jump',
          name: 'externalLawsuitJump', 
          component: () => import('@/view/external/lawsuit/jump.vue'),
        },
{
          path: '/external/lawsuit/onlineSignature',
          name: 'externalLawsuitOnlinesignature', 
          component: () => import('@/view/external/lawsuit/onlineSignature.vue'),
        },
{
          path: '/external/lawsuit/order',
          name: 'externalLawsuitOrder', 
          component: () => import('@/view/external/lawsuit/order.vue'),
        },
{
          path: '/external/loan/analyse',
          name: 'externalLoanAnalyse', 
          component: () => import('@/view/external/loan/analyse.vue'),
        },
{
          path: '/external/loan/analyseApply',
          name: 'externalLoanAnalyseapply', 
          component: () => import('@/view/external/loan/analyseApply.vue'),
        },
{
          path: '/external/loan/analyseCredit',
          name: 'externalLoanAnalysecredit', 
          component: () => import('@/view/external/loan/analyseCredit.vue'),
        },
{
          path: '/external/loan/analysePay',
          name: 'externalLoanAnalysepay', 
          component: () => import('@/view/external/loan/analysePay.vue'),
        },
{
          path: '/external/loan/analyseReport',
          name: 'externalLoanAnalysereport', 
          component: () => import('@/view/external/loan/analyseReport.vue'),
        },
{
          path: '/external/loan/analyseResult',
          name: 'externalLoanAnalyseresult', 
          component: () => import('@/view/external/loan/analyseResult.vue'),
        },
{
          path: '/external/loan/analyseSign',
          name: 'externalLoanAnalysesign', 
          component: () => import('@/view/external/loan/analyseSign.vue'),
        },
{
          path: '/external/loan/analyseType',
          name: 'externalLoanAnalysetype', 
          component: () => import('@/view/external/loan/analyseType.vue'),
        },
{
          path: '/external/loan/approval',
          name: 'externalLoanApproval', 
          component: () => import('@/view/external/loan/approval.vue'),
        },
{
          path: '/external/loan/comfirm',
          name: 'externalLoanComfirm', 
          component: () => import('@/view/external/loan/comfirm.vue'),
        },
{
          path: '/external/loan/detail',
          name: 'externalLoanDetail', 
          component: () => import('@/view/external/loan/detail.vue'),
        },
{
          path: '/external/loan/loanAnalyseComp',
          name: 'externalLoanLoananalysecomp', 
          component: () => import('@/view/external/loan/loanAnalyseComp.vue'),
        },
{
          path: '/external/offlineSignature',
          name: 'externalOfflinesignature', 
          component: () => import('@/view/external/offlineSignature.vue'),
        },
{
          path: '/external/offlineSignPage',
          name: 'externalOfflinesignpage', 
          component: () => import('@/view/external/offlineSignPage.vue'),
        },
{
          path: '/external/owner/complete',
          name: 'externalOwnerComplete', 
          component: () => import('@/view/external/owner/complete.vue'),
        },
{
          path: '/external/owner/detail',
          name: 'externalOwnerDetail', 
          component: () => import('@/view/external/owner/detail.vue'),
        },
{
          path: '/external/peasant/complete',
          name: 'externalPeasantComplete', 
          component: () => import('@/view/external/peasant/complete.vue'),
        },
{
          path: '/external/peasant/detail',
          name: 'externalPeasantDetail', 
          component: () => import('@/view/external/peasant/detail.vue'),
        },
{
          path: '/external/qingdaoJump',
          name: 'externalQingdaojump', 
          component: () => import('@/view/external/qingdaoJump.vue'),
        },
{
          path: '/external/qualification/createOrUpdate',
          name: 'externalQualificationCreateorupdate', 
          component: () => import('@/view/external/qualification/createOrUpdate.vue'),
        },
{
          path: '/external/qualification/list',
          name: 'externalQualificationList', 
          component: () => import('@/view/external/qualification/list.vue'),
        },
{
          path: '/external/quality/complete',
          name: 'externalQualityComplete', 
          component: () => import('@/view/external/quality/complete.vue'),
        },
{
          path: '/external/quality/detail',
          name: 'externalQualityDetail', 
          component: () => import('@/view/external/quality/detail.vue'),
        },
{
          path: '/external/registry',
          name: 'externalRegistry', 
          component: () => import('@/view/external/registry.vue'),
        },
{
          path: '/external/registrySuccess',
          name: 'externalRegistrysuccess', 
          component: () => import('@/view/external/registrySuccess.vue'),
        },
{
          path: '/external/safe/complete',
          name: 'externalSafeComplete', 
          component: () => import('@/view/external/safe/complete.vue'),
        },
{
          path: '/external/safe/detail',
          name: 'externalSafeDetail', 
          component: () => import('@/view/external/safe/detail.vue'),
        },
{
          path: '/external/security/inquiry',
          name: 'externalSecurityInquiry', 
          component: () => import('@/view/external/security/inquiry.vue'),
        },
{
          path: '/external/selectPaytype',
          name: 'externalSelectpaytype', 
          component: () => import('@/view/external/selectPaytype.vue'),
        },
{
          path: '/external/selectSeal',
          name: 'externalSelectseal', 
          component: () => import('@/view/external/selectSeal.vue'),
        },
{
          path: '/external/sign/autograph',
          name: 'externalSignAutograph', 
          component: () => import('@/view/external/sign/autograph.vue'),
        },
{
          path: '/external/sign/signature',
          name: 'externalSignSignature', 
          component: () => import('@/view/external/sign/signature.vue'),
        },
{
          path: '/external/sign/signatureSuccess',
          name: 'externalSignSignaturesuccess', 
          component: () => import('@/view/external/sign/signatureSuccess.vue'),
        },
{
          path: '/external/signature',
          name: 'externalSignature', 
          component: () => import('@/view/external/signature.vue'),
        },
{
          path: '/external/signList',
          name: 'externalSignlist', 
          component: () => import('@/view/external/signList.vue'),
        },
{
          path: '/external/signPage',
          name: 'externalSignpage', 
          component: () => import('@/view/external/signPage.vue'),
        },
{
          path: '/external/teamRisk/complete',
          name: 'externalTeamriskComplete', 
          component: () => import('@/view/external/teamRisk/complete.vue'),
        },
{
          path: '/external/teamRisk/detail',
          name: 'externalTeamriskDetail', 
          component: () => import('@/view/external/teamRisk/detail.vue'),
        },
{
          path: '/external/visitLawyerSms',
          name: 'externalVisitlawyersms', 
          component: () => import('@/view/external/visitLawyerSms.vue'),
        },
{
          path: '/external/webSeal',
          name: 'externalWebseal', 
          component: () => import('@/view/external/webSeal.vue'),
        },
{
          path: '/external/webSealSucc',
          name: 'externalWebsealsucc', 
          component: () => import('@/view/external/webSealSucc.vue'),
        },
]